import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  formControl: {
    marginRight: 50,
  },

  input: {
    width: 50,
    fontSize: "1.6rem",
  },
}));

const TableActions = props => {
  const { count, page, rowsPerPage, onChangePage } = props;
  const classes = useStyles();
  const [pages, setPages] = useState(0);
  const [customPage, setCustomPage] = useState(page + 1);
  const [invalid, setInvalid] = useState(false);
  useEffect(() => {
    setInvalid(customPage < 1 || customPage > pages);
  }, [customPage, pages]);

  useEffect(() => {
    setCustomPage(page + 1);
  }, [page]);

  useEffect(() => {
    setPages(Math.ceil(count / rowsPerPage));
  }, [count, rowsPerPage]);

  const handleBackButtonClick = event => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = event => {
    onChangePage(event, page + 1);
  };

  const handleGo = event => {
    if (!invalid) {
      onChangePage(event, +customPage - 1);
    }
  };

  const handleKeyDown = event => {
    if (!invalid) {
      if (event.key === "Enter") {
        onChangePage(event, +customPage - 1);
      }
    }
  };

  return (
    <Fragment>
      <Typography style={{ paddingLeft: 36, paddingRight: 8 }}>
        Page:
      </Typography>
      <FormControl className={classes.formControl}>
        <TextField
          error={invalid}
          type="number"
          inputProps={{
            min: 1,
            max: pages,
          }}
          classes={{ root: classes.input }}
          value={customPage}
          onChange={event =>
            setCustomPage(event.target.value === "" ? "" : +event.target.value)
          }
          onKeyDown={handleKeyDown}
        />
      </FormControl>
      <Button disabled={invalid} onClick={handleGo}>
        Go
      </Button>

      <IconButton
        disabled={page === 0}
        onClick={handleBackButtonClick}
        aria-label="previous page"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </IconButton>

      <IconButton
        disabled={page >= pages - 1}
        onClick={handleNextButtonClick}
        aria-label="next page"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </IconButton>
    </Fragment>
  );
};

TableActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default TableActions;
